import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Grid,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BaggageRoute from './BaggageRoute';

const BaggageAccordion = ({
  borderColor,
  passenger,
  expanded,
  onChange,
  services,
  selectedBaggage,
  onBaggageSelect,
}) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={onChange}
      elevation={0}
      sx={{
        border: `1px solid ${borderColor}`,
        '&:before': { display: 'none' },
        borderRadius: '8px !important',
        mb: 2,
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          '& .MuiAccordionSummary-content': {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            width: '100%',
            m: 0,
          },
        }}
      >
        <Box
          sx={{
            width: 28,
            height: 28,
            borderRadius: '50%',
            border: `2px solid ${borderColor}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mr: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: borderColor }}>
            {passenger.number}
          </Typography>
        </Box>
        <Typography variant="body1">
          Pasajero{' '}
          <Typography component="span" variant="body2" color="text.secondary">
            {passenger.type}
          </Typography>
        </Typography>
      </AccordionSummary>

      <AccordionDetails sx={{ p: 2 }}>
        <Grid container spacing={2}>
          {passenger.routes.map((route, index) => {
            const handBaggage = route.baggage.filter((b) => b.category === 'HandBaggage');
            const checkedBaggage = route.baggage.filter((b) => b.category === 'Baggage');

            return (
              <Grid item xs={12} md={6} key={index}>
                <BaggageRoute
                  key={`${route.journeyRef}+${passenger.id}+${index}`}
                  direction={route.direction}
                  route={route.route}
                  journeyRef={route.journeyRef}
                  handBaggage={handBaggage}
                  checkedBaggage={checkedBaggage}
                  services={services}
                  passengerId={passenger.id}
                  selectedServices={selectedBaggage[route.journeyRef]}
                  onBaggageSelect={onBaggageSelect}
                  color={borderColor}
                />
              </Grid>
            );
          })}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

export default BaggageAccordion;
